export default "__VITE_ASSET__s4M7h4ZD__"